/* eslint-disable jsx-a11y/iframe-has-title */

import React from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";

export class EditApplication extends React.Component {
  messsagelistener;

  constructor(props) {
    super(props);

    this.state = {
      redirectToUrl: null,
    };

    this.messsagelistener = (e) => {
      if (e.data === "uaQuoteReady") {
        window.location.reload();
      }
    };
    window.addEventListener("message", this.messsagelistener, false);
  }

  componentWillUnmount() {
    window.removeEventListener("message", this.messsagelistener, false);
  }

  componentDidMount() {
    axios
      .get(`${BACKEND_CONFIG.apiUrl}edit-application/${this.props.clientId}`)
      .then((response) => {
        this.setState({ redirectToUrl: response.data.redirectToUrl });
      });
  }

  render() {
    let redirectToUrl = this.state.redirectToUrl;

    return (
      <div>
        {redirectToUrl && (
          <iframe src={redirectToUrl} className="edit-application-frame" />
        )}
      </div>
    );
  }
}
